(() => {
  if (customElements.get('kd-mystery-rotator')) return;

  customElements.define('kd-mystery-rotator', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;

      this.controller = new AbortController();
      this.items = [...this.querySelectorAll('[data-boxer-index]')];
      this.current = Math.max(0, this.items.findIndex(item => item.classList.contains('is-active')));

      this.addEventListener('shopify:block:select', event => {
        const selected = event.target.closest('[data-boxer-index]');
        if (!selected || !this.contains(selected)) return;
        this.show(this.items.indexOf(selected));
        this.restart();
      }, { signal: this.controller.signal });

      if (this.items.length > 1) {
        this.start();
      }
    }

    start() {
      const delay = Math.max(500, Number(this.dataset.interval) || 1500);
      this.timer = window.setInterval(() => this.show(this.current + 1), delay);
    }

    restart() {
      window.clearInterval(this.timer);
      if (this.items.length > 1) this.start();
    }

    show(index) {
      this.current = (index + this.items.length) % this.items.length;
      this.items.forEach((item, itemIndex) => item.classList.toggle('is-active', itemIndex === this.current));
    }

    disconnectedCallback() {
      window.clearInterval(this.timer);
      this.controller?.abort();
      this.controller = null;
    }
  });
})();
